import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useState } from "react";

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  profile?: any;
  session?: any;
}

export const MobileNav = ({
  profile,
  session,
  isOpen,
  onClose,
}: MobileNavProps) => {
  const navigate = useNavigate();
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const [isCorporatesOpen, setIsCorporatesOpen] = useState(false);

  if (!isOpen) return null;

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose();
  };

  return (
    <div className="md:hidden border-t bg-white">
      <div className="container mx-auto px-4 py-2 space-y-2">
        {/* About Us Section */}
        <div className="space-y-2">
          <Button
            variant="ghost"
            onClick={() => setIsAboutOpen(!isAboutOpen)}
            className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
          >
            About Us
          </Button>

          {isAboutOpen && (
            <div className="space-y-2 pl-4 animate-in slide-in-from-top duration-200">
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/about/company")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Company
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/about/team")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Team
              </Button>
            </div>
          )}
        </div>

        {/* For Nonprofits Section */}
        <div className="space-y-2">
          <Button
            variant="ghost"
            onClick={() => setIsSolutionsOpen(!isSolutionsOpen)}
            className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
          >
            For Nonprofits
          </Button>
          {isSolutionsOpen && (
            <div className="space-y-2 pl-4 animate-in slide-in-from-top duration-200">
              <Button
                variant="ghost"
                onClick={() =>
                  handleNavigation("/solutions/community-volunteering")
                }
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Solutions
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/solutions/mission-hub")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Mission Hub
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/solutions/ai-assistant")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                AI Assistant
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/solutions/ai-growth-engine")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                AI Growth Engine
              </Button>
            </div>
          )}
        </div>

        {/* For Corporates Section */}
        <div className="space-y-2">
          <Button
            variant="ghost"
            onClick={() => setIsCorporatesOpen(!isCorporatesOpen)}
            className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
          >
            For Corporates
          </Button>
          {isCorporatesOpen && (
            <div className="space-y-2 pl-4 animate-in slide-in-from-top duration-200">
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/corporate")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Corporate
              </Button>
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/contact")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Contact
              </Button>
            </div>
          )}
        </div>

        {/* Resources Section */}
        <div className="space-y-2">
          <Button
            variant="ghost"
            onClick={() => setIsResourcesOpen(!isResourcesOpen)}
            className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
          >
            Resources
          </Button>

          {isResourcesOpen && (
            <div className="space-y-2 pl-4 animate-in slide-in-from-top duration-200">
              <Button
                variant="ghost"
                onClick={() => handleNavigation("/guides")}
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Guides
              </Button>
              <Button
                variant="ghost"
                onClick={() =>
                  handleNavigation("/guides/disaster-response-guide")
                }
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                Disaster Response Guide
              </Button>
              <Button
                variant="ghost"
                onClick={() =>
                  handleNavigation("/resources/un-campaign-planner")
                }
                className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
              >
                UN Campaign Planner
              </Button>
            </div>
          )}
        </div>

        <Button
          variant="ghost"
          onClick={() => handleNavigation("/contact")}
          className="w-full justify-start text-gray-600 hover:text-primary hover:bg-transparent"
        >
          Contact
        </Button>

        {/* Auth Buttons */}
        {!profile && (
          <div className="pt-4 border-t space-y-2">
            <Button
              variant="ghost"
              onClick={() => handleNavigation("/login")}
              className="w-full justify-center text-gray-600 hover:text-primary hover:bg-transparent"
            >
              Login
            </Button>
            <Button
              onClick={() => handleNavigation("/signup")}
              className="w-full justify-center bg-primary hover:bg-primary-hover text-white"
            >
              Sign Up
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
